import React from "react";
import { Skeleton } from "primereact/skeleton";

function FolderSkeleton() {
  return (
    <div className="grid pr-2 pl-2 pt-3">
      {Array.from({ length: 4 })?.map((_, index) => (
        <div
          key={index}
          className={`field lg:col-3 md:col-3 sm:col-6 xs:col-12 p-0 pr-2`}
        >
          <Skeleton width="100%" height="200px" />
        </div>
      ))}
    </div>
  );
}

export default FolderSkeleton;
